import axios from 'axios';
import { BASE_URL } from './api';


export async function deleteInvoice(invoiceId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/invoices/${invoiceId}/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((response) => response)
}


export async function syncWave(token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/wave_billing/sync/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}


export async function getInvoices(token, queryParams='') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/invoices/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });

}

export async function getInvoicesNeedingReminders(token, queryParams='') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/invoices/get_invoices_needing_reminders/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });

}

export async function updateInvoice(invoiceId, formData, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/invoices/${invoiceId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function markInvoiceSent(invoiceId, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/invoices/${invoiceId}/mark_invoice_sent/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function addInvoicePayment(invoiceId, formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/add_payment/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteInvoicePayment(invoiceId, paymentId, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/payments/${paymentId}/delete/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function waiveInvoiceBalance(invoiceId, formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/waive_balance/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function addInvoiceAccountingNote(invoiceId, formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/add_accounting_post/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function createInvoiceDraft(data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/draft/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data,
    }).then((response) => response.data)
}

export async function saveInvoice(invoiceId, data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/save/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data,
    }).then((response) => response.data)
}

export async function previewInvoicePdf(data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/preview-pdf/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data,
        responseType: 'blob',
    }).then((response) => response.data)
}

export async function attachInvoicePdf(invoiceId, file, token) {
    const data = new FormData()
    data.append('file', file)
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/attach-pdf/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
        data,
    }).then((response) => response.data)
}

export async function listInvoicePdfs(invoiceId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/invoices/${invoiceId}/pdfs/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => response.data)
}

export async function sendInvoiceReminder(invoiceId, data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/invoices/${invoiceId}/send_invoice_reminder/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}